// extracted by mini-css-extract-plugin
export var container = "bXJC3";